export enum ServerEndpoint {
  LOGIN = 'auth/in',
  LOGIN_WITH_GOOGLE = 'auth/google/in',
  LOGIN_CHECK = 'auth/check',
  VERIFY_OTP = 'auth/verify-otp',
  RESEND_OTP = 'auth/resend-otp',
  LOGIN_REFRESH = 'auth/refresh',
  USER_LOGIN = 'auth/user/in',
  USER_REGISTER = 'auth/user/register',
  USER_CHECK = 'auth/user/check',
  USER_ORDERS = 'auth/user/orders',
  USER_FORGOT_PASSWORD = 'auth/user/forgot-password',
  USER_RESET_PASSWORD = 'auth/user/reset-password',
  SIGN_UP = 'sign/new',
  SIGN_UP_WITH_GOOGLE = 'sign/google',
  RESET_PASSWORD = 'auth/resetpswd',
  PROFILE_UPDATE_IMAGE = 'webapp/profile/image',
  
  CONTACT = 'public/contact',
  GEO_LANGUAGE = 'public/geo-language',
  COMMUNITY_JOIN = 'public/community/join',
  NEWSLETTER = 'public/newsletter',
  QUIZ = 'public/quiz',
  SUBMIT_FORM = 'public/submit-form',
  TERMS_HOSTING = 'public/terms-hosting',
  POLICIES = 'public/content/policies',
  INQUIRY = 'public/inquiry',
  GENERATE_REQUEST = 'api/req',
  SERVICES = 'webApp/services/list',
  RAW_USER_USAGE = 'webApp/rawdata/usage',
  RAW_USER_TRAFFIC = 'webApp/rawdata/list',
  RAW_USER_CAPACITY = 'webApp/rawdata/credit',
  SUBSCRIPTIONS = 'webApp/subs/list',
  SUBSCRIPTIONS_SUBSCRIBE = 'webApp/subs/sub',
  RECIPLO_AI_PROMPT = 'webApp/rpai/prompt',
  INGREDIENTS = 'ingrid/grep',
  INGREDIENTS_ANALYZE = 'webapp/recipe/analyze',
  RECEPIES = 'public/recipes',
  RECIPES_USER = 'webapp/recipe/list',
  RECEPIES_SUGGEST = 'webapp/recipe/suggest',
  RECEPIES_GENERATE = 'webapp/recipe/generate',
  PRODUCTS = 'public/products',
  PRODUCTS_NEW = 'admin/products/new',
  PRODUCTS_EDIT = 'admin/products/edit',
  PRODUCTS_DELETE = 'admin/products/delete',
  PROCESS_CART       = 'public/cart',
  SHIPPING_ESTIMATE  = 'public/shipping-estimate',
  ENSURE_CUSTOMER    = 'public/ensure-customer',
  GET_ORDER = 'public/order',
  PRODUCT_STATS = 'public/products/stats',


  ADMIN_ORDERS = 'admin/orders',
  ADMIN_ORDER_STATUS = 'admin/orders',        // used as: ADMIN_ORDER_STATUS + `/${id}/status`
  ADMIN_ORDER_INVOICE_PDF = 'admin/orders',   // used as: + `/${id}/invoice/pdf`
  USER_ORDER_INVOICE_PDF = 'auth/user/orders', // used as: + `/${id}/invoice/pdf`
  ADMIN_PRINT_PRINTERS = 'admin/print/printers',
  ADMIN_PRINT_LABEL    = 'admin/print/label',
  ADMIN_PRINT_TEST     = 'admin/print/test',
  ADMIN_USERS = 'admin/users',
  ADMIN_CUSTOMER_ZOHO      = 'admin/customers/zoho',
  ADMIN_CUSTOMERS_ZOHO_LIST = 'admin/customers/zoho/list',
  ADMIN_LOGS = 'admin/logs/raw',
  ADMIN_BUCKET = 'admin/bucket',
  ADMIN_QUERY = 'admin/query',
  ADMIN_SYSTEM_DATA = 'admin/systemData/list',
  ADMIN_SYSTEM_DATA_FIELD = 'admin/systemData',
  ADMIN_SYSTEM_DATA_NEW = 'admin/systemData/add',
  ADMIN_SYSTEM_DATA_EDIT = 'admin/systemData/update',
  ADMIN_SYSTEM_DATA_DELETE = 'admin/systemData/delete',
  ADMIN_SYSTEM_DATA_PAIR = 'admin/systemData/pair',
  ADMIN_SYSTEM_DATA_SAVE_PAIR = 'admin/systemData/save-pair',
  SYSTEM_DATA = 'admin/systemData',
  UPLOAD_MEDIA = 'admin/systemData/upload-media',

  // ---  Image Categories ---
  CAROUSEL_IMAGES = 'public/images/carousel',
  PARTNERS_IMAGES = 'public/images/partners',
  SPECIALS_IMAGES = 'public/images/specials',
  GALLERY_IMAGES = 'public/images/gallery',
  POP_UP_IMAGE = 'public/images/popup',
  SYSTEM_CONTENT = 'public/content',
  BOOTSTRAP = 'public/content/bootstrap',
  HOME_DATA = 'public/content/home',
  CATEGORIES = 'public/content/categories',
  CONTENT_REVIEWS = 'public/content/reviews',
  CONTENT_LINKS = 'public/content/links',
  BUSINESS_INFO = 'public/content/business-info',
  SERVICES_DATA = 'public/content/services-data',
  PROJECTS_DATA = 'public/content/projects-data',
  CONTENT_FAQ_INFO = 'public/content/faq-cards',
  CONTENT_CARD_INFO = 'public/content/info-cards',
  CONTENT_LOCATIONS = 'public/content/locations',
  LOCATIONS_DATA = 'public/content/locations-data',
  BLOGS_DATA = 'public/content/blogs-data',
  EVENTS_DATA = 'public/content/events-data',
  CONTENT_BANNER = 'public/content/banner-messages',
  CONTENT_PRODUCT_ATTRIBUTES = 'public/content/product-att',
  
  // --- Generate Content ---
  ADMIN_GENERATION_CREDITS = 'admin/generation-credits',
  ADMIN_GENERATE_BLOG      = 'admin/generate-blog',
  ADMIN_GENERATE_EMAIL     = 'admin/generate-email',
  ADMIN_SUGGESTIONS        = 'admin/suggestions',

  // --- Configurations ---
  ADMIN_CONFIG_LIST   = 'admin/config/list',
  ADMIN_CONFIG_KEY    = 'admin/config/key',   // used as: ADMIN_CONFIG_KEY + `/${key}`
  ADMIN_CONFIG_SET    = 'admin/config/set',
  ADMIN_CONFIG_DELETE = 'admin/config/delete',

  // --- Media (same-domain S3 proxy for SEO) ---
  MEDIA = 'media',

  // --- Zoho CRM ---
  ZOHO_DEAL = 'zoho/deal',
  ZOHO_LEAD = 'zoho/lead',
  ZOHO_CONTACT = 'zoho/contact',
  ZOHO_ACCOUNT = 'zoho/account',
}

export enum AutoCompleteEndPoint {
  USE_NAME = 'ac/name',
}

export type ApiEndpoint = ServerEndpoint | AutoCompleteEndPoint;